import _defineProperty from "/tmp/build_5dbe50d0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/tmp/build_5dbe50d0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { e as extend, i as isObject, c as attrToProp, p as paramsList } from './update-swiper.mjs';
import { d as defaults } from './swiper-core.mjs';

var formatValue = function formatValue(val) {
  if (parseFloat(val) === Number(val)) return Number(val);
  if (val === 'true') return true;
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'null') return null;
  if (val === 'undefined') return undefined;

  if (typeof val === 'string' && val.includes('{') && val.includes('}') && val.includes('"')) {
    var v;

    try {
      v = JSON.parse(val);
    } catch (err) {
      v = val;
    }

    return v;
  }

  return val;
};

var modulesParamsList = ['a11y', 'autoplay', 'controller', 'cards-effect', 'coverflow-effect', 'creative-effect', 'cube-effect', 'fade-effect', 'flip-effect', 'free-mode', 'grid', 'hash-navigation', 'history', 'keyboard', 'mousewheel', 'navigation', 'pagination', 'parallax', 'scrollbar', 'thumbs', 'virtual', 'zoom'];

function getParams(element, propName, propValue) {
  var params = {};
  var passedParams = {};
  extend(params, defaults);
  var localParamsList = [].concat(_toConsumableArray(paramsList), ['on']);
  var allowedParams = localParamsList.map(function (key) {
    return key.replace(/_/, '');
  }); // First check props

  localParamsList.forEach(function (paramName) {
    paramName = paramName.replace('_', '');

    if (typeof element[paramName] !== 'undefined') {
      passedParams[paramName] = element[paramName];
    }
  }); // Attributes

  var attrsList = _toConsumableArray(element.attributes);

  if (typeof propName === 'string' && typeof propValue !== 'undefined') {
    attrsList.push({
      name: propName,
      value: isObject(propValue) ? _objectSpread({}, propValue) : propValue
    });
  }

  attrsList.forEach(function (attr) {
    var moduleParam = modulesParamsList.filter(function (mParam) {
      return attr.name.indexOf("".concat(mParam, "-")) === 0;
    })[0];

    if (moduleParam) {
      var parentObjName = attrToProp(moduleParam);
      var subObjName = attrToProp(attr.name.split("".concat(moduleParam, "-"))[1]);
      if (typeof passedParams[parentObjName] === 'undefined') passedParams[parentObjName] = {};

      if (passedParams[parentObjName] === true) {
        passedParams[parentObjName] = {
          enabled: true
        };
      }

      passedParams[parentObjName][subObjName] = formatValue(attr.value);
    } else {
      var name = attrToProp(attr.name);
      if (!allowedParams.includes(name)) return;
      var value = formatValue(attr.value);

      if (passedParams[name] && modulesParamsList.includes(attr.name) && !isObject(value)) {
        if (passedParams[name].constructor !== Object) {
          passedParams[name] = {};
        }

        passedParams[name].enabled = !!value;
      } else {
        passedParams[name] = value;
      }
    }
  });
  extend(params, passedParams);

  if (params.navigation) {
    params.navigation = _objectSpread({
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next'
    }, params.navigation !== true ? params.navigation : {});
  } else if (params.navigation === false) {
    delete params.navigation;
  }

  if (params.scrollbar) {
    params.scrollbar = _objectSpread({
      el: '.swiper-scrollbar'
    }, params.scrollbar !== true ? params.scrollbar : {});
  } else if (params.scrollbar === false) {
    delete params.scrollbar;
  }

  if (params.pagination) {
    params.pagination = _objectSpread({
      el: '.swiper-pagination'
    }, params.pagination !== true ? params.pagination : {});
  } else if (params.pagination === false) {
    delete params.pagination;
  }

  return {
    params: params,
    passedParams: passedParams
  };
}

export { getParams as g };